import { createFileRoute, redirect } from "@tanstack/react-router"

// RETIRED. The standalone full-page record is now the nested people route
// fullscreened: /people/$guestId?focus=2 (same GuestRecord, one ColumnLayout).
// Kept as a redirect so old links / bookmarks still resolve.
export const Route = createFileRoute("/$orgSlug/$eventSlug/person/$guestId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/$eventSlug/people/$guestId",
      params,
      search: { focus: 2 },
    })
  },
})
